import styled from 'styled-components';

export const Logo = styled.img.attrs({
  src: '/logo192.png',
})``;
